import { Directive, OnInit, TemplateRef, ViewContainerRef, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RoleService } from 'src/app/Modules/user-management/permissions/services/role.service';

/**
 * Renders its host only for Järjestelmävalvoja. Uses the same lookup as `systemAdminGuard`
 * (RoleService.getCaller), so a link guarded with it never leads to /unauthorized.
 * Hidden until the API answers, and on any failure.
 */
@Directive({
  selector: '[riSystemAdminOnly]',
  standalone: true,
})
export class SystemAdminOnlyDirective implements OnInit {
  private readonly template = inject(TemplateRef<unknown>);
  private readonly container = inject(ViewContainerRef);
  private readonly roles = inject(RoleService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.roles
      .getCaller()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (caller) => {
          this.container.clear();
          if (caller?.isSystemAdmin) this.container.createEmbeddedView(this.template);
        },
        error: () => this.container.clear(),
      });
  }
}
